import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeConfig } from "../config.js";
import posthog from "@/lib/posthog";
import { getCookieConsent } from "@/components/CookieConsent";

// Initialize configuration when the app starts
initializeConfig().then((config) => {
  const posthogKey = config.get("posthog.key");
  const posthogHost = config.get("posthog.host");
  const apiBaseUrl: string = config.get("api.baseUrl") ?? "";
  const backendRoot = apiBaseUrl.replace(/\/api$/, "");
  const consoleOnly = posthogKey === "dev";
  if (posthogKey) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      ui_host: "https://us.posthog.com",
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error private PostHog option not in public types
      __recorder_js_path: backendRoot ? `${backendRoot}/assets/rec.js` : undefined,
      person_profiles: "identified_only",
      capture_pageview: false,
      capture_pageleave: true,
      scroll_depth: true,
      enable_exception_autocapture: true,
      opt_out_capturing_by_default: getCookieConsent() === "declined",
      before_send: consoleOnly
        ? (event) => { console.log("[PostHog]", event?.event, event?.properties); return null; }
        : undefined,
    });
    posthog.register({ source: 'client' });
  }
  createRoot(document.getElementById("root")!).render(<App />);
}).catch((error: unknown) => {
  console.error("Failed to load configuration:", error);
});
